import type { en } from "./locales/en";

// Recursively produce dot-separated paths for every leaf string in the translation object
type DotPaths<T, Prefix extends string = ""> = {
	[K in keyof T]: T[K] extends Record<string, unknown>
		? DotPaths<T[K], `${Prefix}${K & string}.`>
		: `${Prefix}${K & string}`;
}[keyof T];

export type TranslationKey = DotPaths<typeof en>;

type DeepPartial<T> = {
	[K in keyof T]?: T[K] extends Record<string, unknown>
		? DeepPartial<T[K]>
		: T[K];
};

export type Translations = typeof en;
export type PartialTranslations = DeepPartial<Translations>;

export type SupportedLanguage = "en" | "es" | "zh";

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ["en", "es", "zh"];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
	en: "EN",
	es: "ES",
	zh: "中文",
};

export function isSupportedLanguage(value: string): value is SupportedLanguage {
	return (SUPPORTED_LANGUAGES as string[]).includes(value);
}

// Augment react-i18next so t() is typed against the English translation shape
declare module "react-i18next" {
	interface CustomTypeOptions {
		defaultNS: "translation";
		resources: {
			translation: typeof en;
		};
	}
}
